import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 3v18" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 18,
			height: 18,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 9h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 15h18" })
	]
});
export default SvgTable;
